export interface MasteryBadge {
  id: string;
  label: string;
  icon: string;
  color: string;
  hoverBorder: string;
  earned: boolean;
}

const BADGE_DEFS: Omit<MasteryBadge, 'earned'>[] = [
  {
    id: 'sword',
    label: 'Sword King',
    icon: 'swords',
    color: 'text-[#e03c3c]',
    hoverBorder: 'group-hover:border-[#e03c3c]'
  },
  {
    id: 'axe_shield',
    label: 'Axe Master',
    icon: 'arrow_and_edge',
    color: 'text-[#4caf50]',
    hoverBorder: 'group-hover:border-[#4caf50]'
  },
  {
    id: 'mace',
    label: 'Mace Elite',
    icon: 'mitre',
    color: 'text-[#ffbf00]',
    hoverBorder: 'group-hover:border-[#ffbf00]'
  },
  {
    id: 'tank',
    label: 'Defender',
    icon: 'shield',
    color: 'text-primary',
    hoverBorder: 'group-hover:border-primary'
  },
  {
    id: 'cpvp',
    label: 'Crystal Lord',
    icon: 'diamond',
    color: 'text-[#e03c3c]',
    hoverBorder: 'group-hover:border-[#e03c3c]'
  }
];

/** Badges unlock when 100% of lessons in that gamemode are completed. */
export function computeMasteryBadges(
  stats: Record<string, { total: number; completed: number; percentage: number }>
): MasteryBadge[] {
  const earnedGamemodes = new Set(
    Object.entries(stats)
      .filter(([, data]) => data.total > 0 && data.percentage >= 100)
      .map(([gm]) => gm)
  );

  const badges: MasteryBadge[] = BADGE_DEFS.map((def) => ({
    ...def,
    earned: earnedGamemodes.has(def.id)
  }));

  // Locked placeholder slot (design shows ??? badge)
  badges.push({
    id: 'locked',
    label: '???',
    icon: 'lock',
    color: 'text-on-surface-variant',
    hoverBorder: '',
    earned: false
  });

  return badges;
}
